import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ShopProductCard } from "../shop/ShopProductCard";
import { Reveal } from "../Reveal";
import { SectionHeading } from "../SectionHeading";

// Trending / Best Sellers — REAL published products from the API. Honours
// bestseller/featured flags when present; otherwise shows the catalogue.
export const Bestsellers = ({ products = [] }) => {
  const flagged = products.filter((p) => p.flags?.bestseller || p.flags?.featured);
  const list = (flagged.length ? flagged : products).slice(0, 8);

  if (list.length === 0) return null;

  return (
    <section id="bestsellers" className="scroll-mt-24 border-t border-brand-gold/15 bg-brand-champagne/70 py-20 sm:py-28 lg:py-32" data-testid="bestsellers-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <SectionHeading
              overline="Our Bestsellers"
              title="Customer Favourites"
              text="The bracelets our women reach for again and again — finished and inspected by hand."
            />
            <Link
              to="/shop"
              data-testid="bestsellers-view-all"
              className="group inline-flex items-center gap-2 border-b border-brand-gold/60 pb-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-gold transition-colors hover:border-brand-gold hover:text-brand-gold-hover"
            >
              View all bracelets
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 gap-x-4 gap-y-9 sm:mt-16 sm:gap-6 md:grid-cols-3 lg:grid-cols-4 lg:gap-6" data-testid="bestsellers-grid">
          {list.map((p, i) => (
            <Reveal key={p.id} delay={(i % 4) * 0.1}>
              <ShopProductCard product={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
